import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Color, Icons, MFAType, ModalWorkflowService } from '@lsq-frontend/common-ui';
import { TwoFactorService } from '../two-factor.service';

@Component({
    selector: 'choose-totp-modal',
    template: `
        <form class="modal-content" [formGroup]="chooseMfaFormGroup" (ngSubmit)="chooseMfaMethod()">
            <div class="modal-header" [style.padding-top]="'3rem'">
                <h2 i18n>Enroll New Device</h2>
                <lsq-button
                    appearance="transparent"
                    class="close"
                    ariaLabel="Close"
                    i18n-ariaLabel
                    (buttonClick)="modalWorkflowService.hideWorkflow()"
                >
                    <lsq-icon aria-hidden="true" [type]="icons.Close" [color]="colors.Black">
                    </lsq-icon>
                </lsq-button>
            </div>
            <div class="modal-body">
                <div *ngIf="modalLoading">
                    <lsq-circle-loader></lsq-circle-loader>
                </div>
                <div *ngIf="!modalLoading">
                    <p class="body">
                        To keep your account secure, we require the use of multi-factor
                        authentication. This provides an extra layer of protection in the event your
                        email and password are compromised. Please select which verification option
                        you would prefer to use in order to authenticate access to your account(s):
                    </p>
                    <div class="select-mfa-form-radio-list">
                        <div class="select-mfa-form-radio-list-item">
                            <lsq-radio
                                label="Authenticator Application"
                                [name]="'mfaMethod'"
                                [id]="'mfa-method-authenticator'"
                                [value]="mfaType.TOTP"
                                [group]="chooseMfaFormGroup"
                                formControlName="mfaMethod"
                            >
                            </lsq-radio>
                        </div>
                        <div class="body text-dark-gray radio-subtitle">
                            The default and suggested method for MFA.
                        </div>
                        <div class="select-mfa-form-radio-list-item">
                            <lsq-radio
                                label="SMS Authentication"
                                [name]="'mfaMethod'"
                                [id]="'mfa-method-sms'"
                                [value]="mfaType.SMS"
                                [group]="chooseMfaFormGroup"
                                formControlName="mfaMethod"
                            >
                            </lsq-radio>
                        </div>
                        <div class="body text-dark-gray radio-subtitle">
                            A verification code is sent via SMS, requires a US based number.
                        </div>

                        <div [style.marginTop]="'2rem'"></div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <lsq-button
                    type="submit"
                    size="block"
                    id="submit-choose-button"
                    [submitting]="isSubmitting"
                >
                    Continue
                </lsq-button>
            </div>
        </form>
    `,
    styleUrls: ['./choose-mfa-modal.component.scss']
})
export class ChooseMfaModalComponent {
    public readonly icons = Icons;
    public readonly colors = Color;
    public modalLoading: boolean;
    public mfaType = MFAType;
    public chooseMfaFormGroup = this._formBuilder.group({
        mfaMethod: [MFAType.TOTP, [Validators.required]]
    });

    public isSubmitting = false;

    constructor(
        private _formBuilder: FormBuilder,
        public modalWorkflowService: ModalWorkflowService,
        public twoFactorService: TwoFactorService
    ) {}

    public chooseMfaMethod() {
        var mfaMethod = this.chooseMfaFormGroup.value.mfaMethod;
        if (mfaMethod === MFAType.TOTP) {
            this.twoFactorService.enrollTotpMfa();
        }
        if (mfaMethod === MFAType.SMS) {
            this.twoFactorService.editTwoFactorPhoneNumber();
        }
    }
}
